import { render, staticRenderFns } from "./SliderSemdifQuestion.vue?vue&type=template&id=2d71dc41&scoped=true"
import script from "./SliderSemdifQuestion.vue?vue&type=script&lang=js"
export * from "./SliderSemdifQuestion.vue?vue&type=script&lang=js"
import style0 from "./SliderSemdifQuestion.vue?vue&type=style&index=0&id=2d71dc41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d71dc41",
  null
  
)

export default component.exports